import PropTypes from 'prop-types'
import { H3, P2 } from '@moneymade/moneymade-ui'

import styles from './Platforms.module.scss'

const Platforms = ({ webpartGoodFor: { icons }, float, hide }) => (
  <section className={`${styles.Platforms} ${hide ? styles.Hide : null}`}>
    <div className={`${styles.Tile} ${float ? styles.FloatPosition : styles.FixedPosition}`}>
      {!!icons.length && (
        <>
          <H3 weight="bold" type="heading" className={styles.Header}>
            Good for:
          </H3>
          <div className={styles.Container}>
            {icons.map(({ text, image }, index) => (
              <div key={index} className={`${styles.Item} `}>
                <img alt={text} src={image} />
                <P2 type="main">{text}</P2>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  </section>
)

Platforms.propTypes = {
  webpartGoodFor: PropTypes.shape({
    icons: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        text: PropTypes.string,
        image: PropTypes.string
      })
    )
  }),
  webpartPlatforms: PropTypes.shape({
    slugs: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        text: PropTypes.string,
        image: PropTypes.string
      })
    )
  }),
  float: PropTypes.bool,
  hide: PropTypes.bool
}

Platforms.defaultProps = {
  webpartPlatforms: {
    slugs: []
  },
  webpartGoodFor: {
    icons: []
  },
  float: true,
  hide: true
}

export default Platforms
